<template>
	<div class="i-dots">
		<div class="dot" v-for="(p,i) in list" :class="{active:i===idx}" @click="idx=i"></div>
	</div>
</template>

<script>
export default {

  name: 'i-dots',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>

.dot{
	width:6px;
	height:6px;
	background: white;
	border-radius: 100%;
	display: inline-block;
	margin:5px;
}
.dot.active{
	box-shadow: 0px 0px 15px #00b8ff;
    background: #00b8ff;
}
</style>